import React, {useEffect, useState, useRef} from 'react';
import './login.css';
import firebase from './../../config/fbConfig.js'
import axios from 'axios'

const auth = firebase.auth();
const db = firebase.firestore();

function Login(props) {
	const emailRef = useRef(null);
	const passRef = useRef(null);
	const nickRef = useRef(null);
	const bioRef = useRef(null);

	// isUser means if true = no user exists, false = user does exist
	// NothingEntered, if true means no info was entered
	// Wrong details means wrong password or email entered
	const [error, setError] = useState({isUser: false, nothingEntered: false, wrongDetails: false, shortPass: false})
	const [wantRegister, setRegister] = useState(false)

	// When opening page so focus on email
	useEffect(() => {
		if (!props.isPhone.current) emailRef.current.focus();
		document.getElementById('login').classList.remove('animate');
		setTimeout(() => {
			document.getElementById('login').classList.add('animate');
		}, 10);
	}, [])
	
	// When ticking the checkbox, showing the password
	let showPass = (event) => {
		if (document.forms.login.checkPass.checked) {
			passRef.current.type="text";
		} else {
			passRef.current.type="password";
		}
	};

	// Fired when submitting the form
	let signIn = (e) => {
		e.preventDefault();
		const email = emailRef.current.value;
		const password = passRef.current.value;
		if (email == "" || password == "") {
			setError({...error, nothingEntered: true})
			return;
		}
		if (passRef.current.value.length<7) {
			setError({isUser: false, nothingEntered: false, wrongDetails: false, shortPass: true})
			return;
		}
		if (!wantRegister) {
			// If remember me wasn't ticked
			if (!document.forms.login.RememberMe.checked) {
				firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
				  .then(function() {
				    // Existing and future Auth states are now persisted in the current session only. Closing the window would clear any existing state even if a user forgets to sign out.
				    // New sign-in will be persisted with session persistence.

			  		auth.signInWithEmailAndPassword(email, password).then(cred => {
			  			axios.get("https://api.ipgeolocation.io/ipgeo?apiKey=b13fd8cb1d524e8ab478d9ad7f48d733").then(response => {
							db.collection('accounts').doc(cred.user.uid).update({
								country: response.data['country_name'],
								countryIMG: `https://www.countryflags.io/${response.data['country_code2']}/shiny/64.png`
							});
							props.history.push('/feed');
							alert('Successfully signed in!');
						})
			  		})
			  		.catch(err => {
						if (err.code=='auth/user-not-found') {					
							setError({isUser: true, nothingEntered: false, wrongDetails: false, shortPass: false})
						} else {
							setError({isUser: false, nothingEntered: false, wrongDetails: true, shortPass: false})
						}
			  		});
			  		
				  });
			} else { // If the user wants Remember me, so log in automatically = persistance=local
				auth.signInWithEmailAndPassword(email, password).then(cred => {
					props.history.push('/feed');
					alert('Successfully signed in!');
				})
				.catch(err => {
					if (err.code=='auth/user-not-found') {
						setError({isUser: true, nothingEntered: false, wrongDetails: false})
						return;
					}
					if (email == "" || password == "") {
						setError({isUser: false, nothingEntered: true, wrongDetails: false})
					} else {
						setError({isUser: false, nothingEntered: false, wrongDetails: true})
					}
				});
			}
		} else { // In case the user wants to register
			auth.createUserWithEmailAndPassword(email, password).then(cred => {
				alert('Successfully registered!');
				db.collection('accounts').doc(cred.user.uid).set({
					nickname: nickRef.current.value,
					bio: bioRef.current.value
				}); 
				axios.get("https://api.ipgeolocation.io/ipgeo?apiKey=b13fd8cb1d524e8ab478d9ad7f48d733").then(response => {
					db.collection('accounts').doc(cred.user.uid).update({
						country: response.data['country_name'],
						countryIMG: `https://www.countryflags.io/${response.data['country_code2']}/shiny/64.png`
					});	
					props.history.push('/');
				})
			});
		}
		
	}

	let Register = () => {
		setRegister(true);
		setError({isUser: false, nothingEntered: false, wrongDetails: false});
		setTimeout(() => document.getElementById('wantRegister').classList.add('animate'), 0);		
	}

	return (
		<div id="loginBack">
		<form id="login" onSubmit={signIn}>
			<h1>Login and Sign Up Page!</h1>
			<label htmlFor="email">Enter Email Address</label>
			<input type="email" name="emailAddress" id="email" ref={emailRef}/>
			<label htmlFor="password">Enter Password</label>
			<input type="password" name="password" id="password" ref={passRef}/>
			{error.isUser && 
				<div id="err">Sorry, this account doesn't exist.
				<p>However, you can register with these details if you click <u onClick={Register}><b>Here</b></u>.</p></div>}
			{error.nothingEntered && <div id="err">Sorry, you didn't enter anything, what'd you expect huh?</div>}
			{error.wrongDetails && <div id="err">You entered wrong password/email.</div>}
			{error.shortPass && <div id="err">You must enter more than 7 characters for your password.</div>}

	       		{wantRegister && <div id="wantRegister">
	       			<label htmlFor="nickname">Enter Nickname</label>
		       		<input type="text" id="nickname" ref={nickRef} required/>
					<label htmlFor="password">Enter Bio</label>
					<textarea id="password" ref={bioRef} required/>
				</div>}

				<input type="checkbox" onClick={showPass} name="checkPass"/>Show Password
				<div>
					<input type="checkbox" name="RememberMe"/>Remember me
				</div>
				<button type="submit">Sign In!</button>
  
			
			
		</form>
		</div>
	)
}

export default Login